import axios from 'axios';
import { ButtonGroup, ComboBox, DataGrid, Dialog, Form, FormField, GridColumn, Label, Layout, LayoutPanel, LinkButton, Panel, TextBox } from 'rc-easyui';
import React, { Component } from 'react';
import { uAPIlocal } from '../../lib/config';
import Loader from 'react-loader-spinner';
import { Row, Col } from "react-bootstrap";
import { Button, DatePicker, TimePicker, Checkbox, Space, Flex, Radio } from 'antd';
import ButtonDownloadTable from './ComponentToDownloadTable';
import ButtonDownloadPDF from './ButtonPrintRekapitulasi';
import dayjs from 'dayjs';
import Select from 'react-select';
import Cookies from 'js-cookie';
import moment from "moment";
import 'moment/locale/id';
let source = axios.CancelToken.source();
axios.defaults.withCredentials = true;

const numberFormat = (value) =>
    new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(value);

const { RangePicker } = DatePicker;

class MasterKonsultasi extends Component {
    constructor(props) {
        super(props);
        this.state = {
            master_finance: {
                total: 0,
                pageSize: 20,
                data: [],
                result: [],
                pagePosition: "bottom",
                pageOptions: {
                    layout: ['list', 'sep', 'first', 'prev', 'next', 'last', 'sep', 'refresh', 'sep', 'manual', 'info']
                },
                selection: null,
                loading: true,
                startdate: "",
                enddate: "",
            },
            formTambah: {
                field: {
                    ID_DOKTER: "",
                    NAMA_DOKTER: "",
                    ALAMAT: "",
                    NO_TELP: "",
                    SIP: "",
                },
                rules: {
                    ID_DOKTER: ["required"],
                    NAMA_DOKTER: ["required"],
                    ALAMAT: ["required"],
                    NO_TELP: ["required"],
                    SIP: ["required"],
                }
            },
            formEdit: {
                field: {
                    ID_DOKTER: "",
                    NAMA_DOKTER: "",
                    ALAMAT: "",
                    NO_TELP: "",
                    SIP: "",
                },
                rules: {
                    ID_DOKTER: ["required"],
                    NAMA_DOKTER: ["required"],
                    ALAMAT: ["required"],
                    NO_TELP: ["required"],
                    SIP: ["required"],
                }
            },
            loader: false,
        }
        this.getData = this.getData.bind(this);
        this.errorDialog = React.createRef();
        this.tambahConc = React.createRef();
        this.editConc = React.createRef();

        this.pageChange = this.pageChange.bind(this);
        this.selectionChange = this.selectionChange.bind(this);

        this.formTambah = React.createRef();
        this.handleChangeFormTambah = this.handleChangeFormTambah.bind(this);
        this.handleSubmitFormTambah = this.handleSubmitFormTambah.bind(this);

        this.formEdit = React.createRef();
        this.handleEditClick = this.handleEditClick.bind(this);
        this.handleChangeformEdit = this.handleChangeformEdit.bind(this);
        this.handleSubmitformEdit = this.handleSubmitformEdit.bind(this);

        this.removeDialog = React.createRef();
        this.removedData = this.removedData.bind(this);
        this.handleRemoveClick = this.handleRemoveClick.bind(this);
        source = axios.CancelToken.source()
    }

    async getData() {
        this.setState({
            master_finance: {
                ...this.state.master_finance,
                data: [],
                loading: true
            }
        })

        var _b = this.state.chooseBranchPatient?.value;
        if (_b == undefined || _b == "") {
            _b = "ALL";
        } else {
            _b = this.state.chooseBranchPatient?.value;
        }


        let e = 'finance';
        await axios.post(uAPIlocal + `/api/v1/patient/${e}?branch=${_b}&start=${this.state.master_finance.startdate}&end=${this.state.master_finance.enddate}`)
            .then(function (response) {
                console.log(response, "this is response")
                return response.data;
            })
            .then(async response => {
                console.log("mydata pasien finance", response.results);

                // console.log("datasort", datasort);

                let mydata = response.results;

                mydata.forEach(function (el, index) {
                    el.TGL_LAYANAN_FORMATTED = moment(moment.utc(el.TGL_LAYANAN)).local().format("DD/MM/YYYY");
                });

                console.log("mydatamydata", mydata);


                const setData = (event) => {
                    const _datas = mydata.filter(x => x.STATUS_PEMBAYARAN === "Lunas");
                    var res = _datas.map(x => Number(x.TOTAL_HARGA)).reduce((acc, amount) => acc + amount);

                    let totalKonsultasi = 0;
                    let totalDokter = 0;

                    _datas.map((item, index) => {
                        let num = 0;
                        let num2 = 0;
                        if (item.PEMBAYARAN_KONSULTASI == 1 || item.PEMBAYARAN_KONSULTASI == 3) {
                            num = 0;
                            num2 = 0;
                        } else if (item.PEMBAYARAN_KONSULTASI == 0) {
                            num = Number(item.HARGA_KONSULTASI - ((25 / 100) * item.HARGA_KONSULTASI));
                            num2 = Number((25 / 100) * item.TOTAL_HARGA);

                        } else if (item.PEMBAYARAN_KONSULTASI == 2) {
                            let _step1 = item.HARGA_KONSULTASI - ((item.PEMBAYARAN_DISKON / 100) * item.HARGA_KONSULTASI);
                            num = Number(_step1 - ((25 / 100) * _step1));

                            let _step2 = item.HARGA_KONSULTASI - ((item.PEMBAYARAN_DISKON / 100) * item.HARGA_KONSULTASI);
                            num2 = Number((25 / 100) * _step2)
                        } else {
                            num = 0;
                            num2 = 0;
                        }

                        totalKonsultasi = totalKonsultasi + num;
                        totalDokter = totalDokter + num2;


                    });


                    this.setState({
                        master_finance: {
                            ...this.state.master_finance,
                            data: _datas,
                            loading: false,
                            total: res
                        }
                    }, () => this.addTotal(res, totalKonsultasi, totalDokter))
                };

                if (response.results.length > 0) {
                    await response.results.map(async function (item, index) {
                        let getDetail = await axios.post(uAPIlocal + `/api/v1/detail-patient/${item.ID_REGISTRASI}`, {
                            cancelToken: source.token
                        })

                        console.log("mydata pasien detail", getDetail.data.results[0]);

                        if (getDetail.data.results[0]) {
                            let keyIndex = response.results.findIndex((x) => x.ID_REGISTRASI === getDetail.data.results[0].ID_REGISTRASI);
                            if (index != -1) {
                                var newKey = "STATUS_PEMBAYARAN";
                                var newVal = getDetail.data.results[0].STATUS;
                                mydata[keyIndex]["ID_PEMBAYARAN"] = getDetail.data.results[0].ID_PEMBAYARAN;
                                mydata[keyIndex]["ID_KONSULTASI"] = getDetail.data.results[0].ID_KONSULTASI;
                                mydata[keyIndex]["DATE_PEMBAYARAN"] = getDetail.data.results[0].DATE_PEMBAYARAN;
                                mydata[keyIndex]["METODE_PEMBAYARAN"] = getDetail.data.results[0].METODE_PEMBAYARAN;
                                mydata[keyIndex]["TOTAL_HARGA"] = Number(getDetail.data.results[0].TOTAL_HARGA);
                                mydata[keyIndex]["statusSelesai"] = getDetail.data.results[0].statusSelesai;
                                mydata[keyIndex]["KETERANGAN_BIAYA_KONSULTASI"] = getDetail.data.results[0].KETERANGAN_BIAYA_KONSULTASI;
                                mydata[keyIndex]["SURAT_SAKIT_HARI"] = getDetail.data.results[0].SURAT_SAKIT_HARI;
                                mydata[keyIndex][newKey] = newVal;
                            } else { }
                        } else {
                            let keyIndex = response.results.findIndex((x) => x.ID_REGISTRASI === item.ID_REGISTRASI);
                            var newKey = "STATUS_PEMBAYARAN";
                            var newVal = "Belum Dibayar";
                            mydata[keyIndex][newKey] = newVal;
                        }

                        if (response.results.length == (index + 1)) {
                            setTimeout(() => {
                                setData();
                            }, 3000);
                        }


                    });
                }



            })
            .catch(function (error) {
                console.log(error);
            });


    }

    async addTotal(res, con, doc) {
        this.setState({
            master_finance: {
                ...this.state.master_finance,
                data: [...this.state.master_finance.data,
                {
                    STATUS: "",
                    TGL_LAYANAN: "",
                    NAMA_PASIEN: "",
                    METODE_PEMBAYARAN: "",
                    TOTAL_HARGA: res,
                    KONSULTASI_HARGA: con,
                    DOKTER_HARGA: doc
                }],
            }
        })
    }

    async getBranch() {
        await axios.post(uAPIlocal + `/api/v1/branch`)
            .then(function (response) {
                console.log(response, "this is response")
                return response.data;
            })
            .then(response => {
                console.log("mydata branch", response.results);
                const _datas = response.results.sort(function (a, b) {
                    return a.branch_name > b.branch_name;
                });


                let branch = [];
                branch.push({
                    value: "",
                    label: "-- Semua Cabang --",
                })
                if (_datas.length > 0) {
                    _datas.forEach(element => {
                        if (element.branch_code) {
                            branch.push({
                                value: element.branch_code,
                                label: element.branch_name,
                            })
                        }
                    });
                }

                this.setState({ optBranch: branch }, () =>
                    console.log("ok")
                )

                let indexBranch = this.state.optBranch.findIndex(function (item, i) {
                    return item.value === localStorage.getItem("branch")
                });

                this.setState({ chooseBranch: this.state.optBranch[indexBranch], chooseBranchPatient: this.state.optBranch[indexBranch] })

            })
            .catch(function (error) {
                console.log(error);
            });
    }

    changeSelectBranch = (e) => {
        console.log('change branch', e)
        this.setState({ chooseBranchPatient: e }, () => setTimeout(() => {
            this.getData()
        }, 1000))
    }

    pageChange(event) {
        // console.log(event)
        if (event.refresh) {
            // console.log(event)
            this.setState({
                master_finance: {
                    ...this.state.master_finance,
                    loading: true,
                    selection: null
                },
            })
            this.getData();
        }

    }
    async selectionChange(event) {
        // console.log(event)
        await this.setState({
            master_finance: {
                ...this.state.master_finance,
                selection: event
            },
        })
    }

    async handleChangeFormTambah(name, value) {
        let field = Object.assign({}, this.state.formTambah.field);
        field[name] = value;
        await this.setState({
            formTambah: {
                ...this.state.formTambah,
                field: field
            }
        }, () => console.log(this.state.formTambah.field))
    }

    async handleSubmitFormTambah() {
        const formData = new FormData();
        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        };
        const ID_DOKTER = this.state.formTambah.field.ID_DOKTER;
        const NAMA_DOKTER = this.state.formTambah.field.NAMA_DOKTER;
        const ALAMAT = this.state.formTambah.field.ALAMAT;
        const NO_TELP = this.state.formTambah.field.NO_TELP;
        const SIP = this.state.formTambah.field.SIP;
        formData.append('ID_DOKTER', ID_DOKTER);
        formData.append('NAMA_DOKTER', NAMA_DOKTER);
        formData.append('ALAMAT', ALAMAT);
        formData.append('NO_TELP', NO_TELP);
        formData.append('SIP', SIP);

        for (var pair of formData.entries()) {
            console.log(pair[0] + ': ' + pair[1]);
        }

        if (ID_DOKTER == '' || NAMA_DOKTER == '' || ALAMAT == '' || NO_TELP == '') {

            this.setState({
                errorMessage: "Form tidak boleh kosong!",
            })
            this.errorDialog.current.open();

        } else {
            await axios.post(uAPIlocal + '/api/v1/master_finance', formData, config)
                .then(response => {
                    // console.log(response)
                    if (response.data.status === 406) {
                        this.setState({
                            errorMessage: response.data.message,
                        })
                        this.errorDialog.current.open();
                    } else {
                        this.getData();
                        this.tambahConc.current.close();
                        this.setState({
                            formTambah: {
                                ...this.state.formTambah,
                                field: {
                                    ID_DOKTER: "",
                                    NAMA_DOKTER: "",
                                    ALAMAT: "",
                                    NO_TELP: "",
                                    SIP: "",
                                },
                            }
                        })
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        }

    }

    async handleRemoveClick() {
        if (this.state.master_finance.selection) {
            this.removeDialog.current.open();
        } else {
            // console.log('tidak ada yang di select');
            this.setState({
                errorMessage: "Tidak Ada Data yang Dipilih",
            })
            this.errorDialog.current.open();
        }
    }

    async removedData() {
        await this.setState({
            loader: true
        })
        const id = this.state.master_finance.selection.ID_DOKTER
        await axios.delete(uAPIlocal + `/api/v1/master_finance/${id}`)
            .then(function (response) {
                // console.log(response)this.state.pasien.selection.id_regis
                return response.data;
            })
            .then(response => {
                // console.log(response)
                this.getData();
                this.removeDialog.current.close();
                this.setState({
                    loader: false,
                    master_finance: {
                        ...this.state.master_finance,
                        selection: null
                    },
                })




            })
            .catch(error => {
                console.log(error);
                if (error.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    // console.log(error.response.data);
                    // console.log(error.response.status);
                    // console.log(error.response.headers);
                    if (error.response.status === 500) {
                        this.setState({
                            loader: false,
                            errorMessage: error.response.data,
                        })
                        this.errorDialog.current.open();
                    }
                } else if (error.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js
                    // console.log(error.request);
                    this.setState({
                        loader: false,
                        errorMessage: "Terjadi Kesalahan",
                    })
                    this.errorDialog.current.open();
                } else {
                    // Something happened in setting up the request that triggered an Error
                    // console.log('Error', error.message);
                    this.setState({
                        loader: false,
                        errorMessage: "Terjadi Kesalahan",
                    })
                    this.errorDialog.current.open();
                }

            });
    }

    async handleEditClick() {
        if (this.state.master_finance.selection) {
            console.log(this.state.master_finance.selection)
            const ID_DOKTER = `${this.state.master_finance.selection.DokterID}`
            const NAMA_DOKTER = `${this.state.master_finance.selection.NAMA_DOKTER}`
            const ALAMAT = `${this.state.master_finance.selection.ALAMAT}`
            const NO_TELP = `${this.state.master_finance.selection.NO_TELP}`
            const SIP = `${this.state.master_finance.selection.SIP}`
            await this.setState({
                formEdit: {
                    ...this.state.formEdit,
                    field: {
                        ID_DOKTER: ID_DOKTER,
                        NAMA_DOKTER: NAMA_DOKTER,
                        ALAMAT: ALAMAT,
                        NO_TELP: NO_TELP,
                        SIP: SIP,
                    },
                }
            })
            this.editConc.current.open();
        } else {
            // console.log('tidak ada yang di select');
            this.setState({
                errorMessage: "Tidak Ada Data yang Dipilih",
            })
            this.errorDialog.current.open();
        }
    }

    async handleChangeformEdit(name, value) {
        let field = Object.assign({}, this.state.formEdit.field);
        field[name] = value;
        await this.setState({
            formEdit: {
                ...this.state.formEdit,
                field: field
            }
        })
    }
    async handleSubmitformEdit() {
        const formData = new FormData();
        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        };
        const ID_DOKTER = this.state.formEdit.field.ID_DOKTER;
        const NAMA_DOKTER = this.state.formEdit.field.NAMA_DOKTER;
        const ALAMAT = this.state.formEdit.field.ALAMAT;
        const NO_TELP = this.state.formEdit.field.NO_TELP;
        const SIP = this.state.formEdit.field.SIP;
        formData.append('ID', this.state.master_finance.selection.ID_DOKTER);
        formData.append('ID_DOKTER', ID_DOKTER);
        formData.append('NAMA_DOKTER', NAMA_DOKTER);
        formData.append('ALAMAT', ALAMAT);
        formData.append('NO_TELP', NO_TELP);
        formData.append('SIP', SIP);

        for (var pair of formData.entries()) {
            console.log(pair[0] + ': ' + pair[1]);
        }

        if (ID_DOKTER == '' || NAMA_DOKTER == '' || ALAMAT == '' || NO_TELP == '') {

            this.setState({
                errorMessage: "Form tidak boleh kosong!",
            })
            this.errorDialog.current.open();

        } else {

            await axios.put(uAPIlocal + '/api/v1/master_finance', formData, config)
                .then(response => {
                    if (response.data.status === 406) {
                        this.setState({
                            errorMessage: response.data.message,
                        })
                        this.errorDialog.current.open();
                    } else {
                        this.setState({
                            master_finance: {
                                ...this.state.master_finance,
                                loading: true
                            }
                        })
                        this.getData();
                        this.editConc.current.close();
                        this.setState({
                            formEdit: {
                                ...this.state.formEdit,
                                field: {
                                    ID_DOKTER: "",
                                    NAMA_DOKTER: "",
                                    ALAMAT: "",
                                    NO_TELP: "",
                                    SIP: "",
                                },
                            }
                        })
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });

        }

    }

    onChange = (value) => {
        // this.setState({ TimeRanges: [], opsiJam: [] });
        // console.log("ini hasil ant", value);

        if (value) {
            // this.setState({ TimeRanges: value });
            // let start = moment(value[0].$H, 'H').format('HH') + ':00:00'
            // let end = moment(value[1].$H, 'H').format('HH') + ':00:00'

            let start = moment(value[0].$d).format('YYYY-MM-DD') + " 00:00:00";
            let end = moment(value[1].$d).format('YYYY-MM-DD') + " 00:00:00";

            this.setState({
                master_finance: {
                    ...this.state.master_finance,
                    startdate: start,
                    enddate: end
                }
            }, () => this.getData())
        }

    }

    componentDidMount() {
        this.getBranch();
        setTimeout(() => {
            this.getData();
        }, 1000);

    }
    componentWillUnmount() {
        window.location.reload();
    }
    render() {
        return (

            <Row>
                <Dialog
                    title="Alert"
                    style={{ width: '300px', height: '84px' }}
                    modal
                    closed={true}
                    ref={this.errorDialog}
                >
                    <p style={{ textAlign: 'center', margin: '10px', fontSize: '16px' }}>{this.state.errorMessage}</p>
                </Dialog>

                <Dialog title="Tambah Dokter"
                    style={{ width: '500px', }}
                    modal
                    closed={true}
                    ref={this.tambahConc}
                >
                    <div className='pd-20'>
                        <Form
                            ref={this.formTambah}
                            style={{ maxWidth: 500 }}
                            model={this.state.formTambah.field}
                            rules={this.state.formTambah.rules}
                            labelWidth={200}
                            // labelAlign="right"
                            labelPosition="top"
                            // floatingLabel
                            // validateRules={this.getCustomRules}
                            onChange={this.handleChangeFormTambah}
                        >
                            <FormField name="ID_DOKTER" label="ID Dokter">
                                <TextBox inputId="t0" name="fid" value={this.state.formTambah.field.ID_DOKTER} style={{ width: '100%' }}></TextBox>
                            </FormField>
                            <FormField name="NAMA_DOKTER" label="Nama Dokter">
                                {/* <ComboBox data={this.state.Test_Code} value={this.state.formTambah.field.Test_ID} ></ComboBox> */}
                                <TextBox inputId="t1" name="ftestid" value={this.state.formTambah.field.NAMA_DOKTER} style={{ width: '100%' }}></TextBox>
                            </FormField>
                            <FormField name="ALAMAT" label="Alamat">
                                <TextBox inputId="t2" name="ftestname" value={this.state.formTambah.field.ALAMAT} style={{ width: '100%' }}></TextBox>
                            </FormField>
                            <FormField name="NO_TELP" label="No. Telp">
                                <TextBox inputId="t3" name="fconcid" value={this.state.formTambah.field.NO_TELP} style={{ width: '100%' }}></TextBox>
                            </FormField>
                            <FormField name="SIP" label="No. SIP">
                                <TextBox inputId="t4" name="fsip" value={this.state.formTambah.field.SIP} style={{ width: '100%' }}></TextBox>
                            </FormField>
                            <FormField >
                                <LinkButton onClick={this.handleSubmitFormTambah} >Submit</LinkButton>
                            </FormField>
                        </Form>
                    </div>
                </Dialog>

                <Dialog title="Edit Dokter"
                    style={{ width: '500px', }}
                    modal
                    closed={true}
                    ref={this.editConc}
                >
                    <div className='pd-20'>
                        <Form
                            ref={this.formEdit}
                            style={{ maxWidth: 500 }}
                            model={this.state.formEdit.field}
                            rules={this.state.formEdit.rules}
                            labelWidth={200}
                            // labelAlign="right"
                            labelPosition="top"
                            // floatingLabel
                            // validateRules={this.getCustomRules}
                            onChange={this.handleChangeformEdit}
                        >
                            <FormField name="ID_DOKTER" label="ID Dokter">
                                <TextBox inputId="t0" name="fid" value={this.state.formEdit.field.ID_DOKTER} style={{ width: '100%' }}></TextBox>
                            </FormField>
                            <FormField name="NAMA_DOKTER" label="Nama Dokter">
                                <TextBox inputId="t1" name="ftestid" value={this.state.formEdit.field.NAMA_DOKTER} style={{ width: '100%' }}></TextBox>
                            </FormField>
                            <FormField name="ALAMAT" label="Alamat">
                                <TextBox inputId="t2" name="ftestname" value={this.state.formEdit.field.ALAMAT} style={{ width: '100%' }}></TextBox>
                            </FormField>
                            <FormField name="NO_TELP" label="No. Telp">
                                <TextBox inputId="t3" name="fconcid" value={this.state.formEdit.field.NO_TELP} style={{ width: '100%' }}></TextBox>
                            </FormField>
                            <FormField name="SIP" label="No. SIP">
                                <TextBox inputId="t4" name="fsip" value={this.state.formEdit.field.SIP} style={{ width: '100%' }}></TextBox>
                            </FormField>
                            <FormField >
                                <LinkButton onClick={this.handleSubmitformEdit} >Submit</LinkButton>
                            </FormField>
                        </Form>
                    </div>
                </Dialog>
                <Dialog
                    title="Please Confirm"
                    style={{ width: '300px', height: '190px' }}
                    modal
                    closed={true}
                    ref={this.removeDialog}
                    footer={() => {
                        return (
                            this.state.loader ? (
                                <div className="text-center">
                                    <Loader type="TailSpin" color="#00BFFF" height={40} width={100} />
                                </div>
                            ) : (

                                <>
                                    <ButtonGroup style={{ width: '100%', height: '50px' }}>
                                        <LinkButton className="f-full mybtn" plain onClick={this.removedData}>Yakin</LinkButton>
                                        <LinkButton className="f-full mybtn" plain onClick={() => this.removeDialog.current.close()}>Cancel</LinkButton>
                                    </ButtonGroup>
                                </>
                            )
                        )
                    }}

                >
                    <>
                        <p style={{ textAlign: 'center', margin: '10px', fontSize: '16px' }}>Apakah Anda Yakin ?</p>

                    </>
                </Dialog>


                <div className="container overflow-hidden" style={{ backgroundColor: "white", padding: "2px" }} >
                    <Panel
                        title="Master Finance"
                        collapsible
                    // bodyStyle={{ padding: 20 }}
                    // style={{ height: 500 }}
                    >
                        <div className="row g-0">
                            {/* <Col className="col-8">
                                <div style={{ marginTop: 10, marginLeft: 4 }}>
                                    <LinkButton
                                        iconCls="icon-add"
                                        style={{ margin: 4 }}
                                        // onClick={() => this.addRow()}
                                        onClick={() => this.tambahConc.current.open()}
                                    >
                                        Tambah
                                    </LinkButton>
                                    <LinkButton
                                        iconCls="icon-edit"
                                        style={{ margin: 4 }}
                                        // onClick={() => this.editRow()}
                                        onClick={this.handleEditClick}
                                        disabled={this.state.master_finance.selection ? false : true}
                                    >
                                        Ubah
                                    </LinkButton>
                                    <LinkButton
                                        iconCls="icon-cancel"
                                        style={{ margin: 4 }}
                                        // onClick={() => this.deleteRow()}
                                        onClick={this.handleRemoveClick}
                                        disabled={this.state.master_finance.selection ? false : true}
                                    >
                                        Hapus
                                    </LinkButton>




                                </div>
                            </Col> */}

                            <Col className="col-6">

                                <div className="row g-2">

                                    <Col className="col-4">

                                        <Select
                                            // className='title'
                                            value={this.state.chooseBranchPatient}
                                            name="dept"
                                            options={this.state.optBranch}
                                            placeholder="Pilih Cabang"
                                            onChange={this.changeSelectBranch}
                                            menuPosition={'fixed'}
                                            styles={{
                                                menu: provided => ({ ...provided, zIndex: 9999 }),
                                                control: (baseStyles, state) => ({
                                                    ...baseStyles,
                                                    borderColor: state.isFocused ? 'grey' : '#7E7E7E',
                                                    color: "#000",
                                                    // backgroundColor: 'rgba(231,230,227,255)',
                                                    // borderRadius: '10px',
                                                    width: "100%",
                                                    fontSize: '12px',
                                                    margin: 4
                                                    // float: 'right'
                                                }),
                                                option: provided => ({
                                                    ...provided,
                                                    fontSize: '12px',
                                                    zIndex: 999,
                                                }),
                                                dropdownIndicator: styles => ({
                                                    ...styles,
                                                    color: '#000',
                                                }),
                                                indicatorsContainer: (base) => ({
                                                    ...base,
                                                    minHeight: 1,
                                                }),
                                                indicatorSeparator: () => null,
                                            }}
                                        />

                                    </Col>

                                    <Col className="col-4">
                                        <div style={{ display: Cookies.get('biomedika-level') == 3 ? null : 'none' }}>
                                            {
                                                this.state.master_finance.data.length > 0 ? (<ButtonDownloadTable item={this.state.master_finance} />) : null
                                            }
                                        </div>
                                    </Col>
                                    <Col className="col-4">
                                        <div style={{ display: Cookies.get('biomedika-level') == 3 ? null : 'none' }}>
                                            {
                                                this.state.master_finance.data.length > 0 ? (<ButtonDownloadPDF item={this.state.master_finance} />) : null
                                            }
                                        </div>
                                    </Col>


                                    {/* <Col className="col-6" style={{ display: Cookies.get('biomedika-level') == 3 ? null : 'none' }}>
                                        <Row>
                                            <Col className="col-6">
                                                {
                                                    this.state.master_finance.data.length > 0 ? (<ButtonDownloadTable item={this.state.master_finance} />) : null
                                                }
                                            </Col>
                                            <Col className="col-6">
                                                {
                                                    this.state.master_finance.data.length > 0 ? (<ButtonDownloadPDF item={this.state.master_finance} />) : null
                                                }
                                            </Col>
                                        </Row>
                                    </Col> */}

                                </div>




                                {/* <p>TOTAL : <span>Rp.{numberFormat(this.state.master_finance.total).replace("Rp", "")}</span></p> */}
                            </Col>

                            <Col className="col-6">
                                <div style={{ float: 'right' }}>
                                    <RangePicker
                                        onChange={this.onChange}
                                        style={{ height: '40px', margin: 4 }}
                                    />

                                </div>

                            </Col>




                        </div>

                        {/*                         
                        <div className="row justify-content-end" >



                                    <Col className="">
                                        <ButtonGroup>
                                         
                                            <Select
                                                className='title'
                                                value={this.state.chooseBranchPatient}
                                                name="dept"
                                                options={this.state.optBranch}
                                                placeholder="Pilih Cabang"
                                                onChange={this.changeSelectBranch}
                                                menuPosition={'fixed'}


                                                styles={{
                                                    menu: provided => ({ ...provided, zIndex: 9999 }),
                                                    control: (baseStyles, state) => ({
                                                        ...baseStyles,
                                                        borderColor: state.isFocused ? 'grey' : '#7E7E7E',
                                                        color: "#000",
                                                        // backgroundColor: 'rgba(231,230,227,255)',
                                                        // borderRadius: '10px',
                                                        width: "180px",
                                                        fontSize: '12px',
                                                    }),
                                                    option: provided => ({
                                                        ...provided,
                                                        fontSize: '12px',
                                                        zIndex: 999,
                                                    }),
                                                    dropdownIndicator: styles => ({
                                                        ...styles,
                                                        color: '#000',
                                                    }),
                                                    indicatorsContainer: (base) => ({
                                                        ...base,
                                                        minHeight: 1,
                                                    }),
                                                    indicatorSeparator: () => null,
                                                }}
                                            />

                                        </ButtonGroup>




                                    </Col>



                                </div> */}

                        <div id="DataGrid">
                            <DataGrid
                                {...this.state.master_finance}
                                style={{ height: '70vh', }}
                                pagination
                                columnResizing
                                selectionMode="single"
                                onSelectionChange={this.selectionChange}
                                // onPageChange={this.pageChange}
                                filterable
                                virtualScroll
                                columnMoving
                            >
                                <GridColumn
                                    field="TGL_LAYANAN"
                                    title="TGL REG."
                                    align="center"
                                    width="60px"
                                    render={({ row }) => {
                                        if (row.TGL_LAYANAN == "") {
                                            return <></>
                                        } else {
                                            return <>{moment(moment.utc(row.TGL_LAYANAN)).local().format("DD/MM/YYYY")}</>
                                        }
                                    }}
                                ></GridColumn>
                                {/* <GridColumn
                                    field="NOMR"
                                    title="NOMR"
                                    width="40px"
                                    align="center"
                                ></GridColumn> */}
                                <GridColumn
                                    field="STATUS"
                                    title="STATUS"
                                    width="80px"
                                    align="center"
                                ></GridColumn>
                                {/* <GridColumn
                                    field="ID_REGISTRASI"
                                    title="ID_REGISTRASI"
                                    width="40px"
                                    align="center"
                                ></GridColumn> */}
                                <GridColumn
                                    sortable
                                    field="NAMA_PASIEN"
                                    title="NAMA PASIEN"
                                    align="center"
                                    width="100px"
                                ></GridColumn>

                                <GridColumn
                                    sortable
                                    field="NAMA_DOKTER"
                                    title="NAMA DOKTER"
                                    align="center"
                                    width="100px"
                                ></GridColumn>

                                <GridColumn
                                    sortable
                                    field="branch_name"
                                    title="CABANG"
                                    align="center"
                                    width="100px"
                                ></GridColumn>


                                <GridColumn
                                    field="METODE_PEMBAYARAN"
                                    title="METODE PEMBAYARAN"
                                    align="center"
                                    width="100px"
                                    render={({ row }) => {
                                        if (row.TGL_LAYANAN == "") {
                                            return <b>{row.METODE_PEMBAYARAN}</b>
                                        } else {
                                            return <>{row.METODE_PEMBAYARAN}</>
                                        }
                                    }}
                                ></GridColumn>

                                <GridColumn
                                    field="TOTAL_HARGA"
                                    title="BRUTO"
                                    align="center"
                                    width="100px"
                                    hidden={Cookies.get('biomedika-level') == 5 ? false : true}
                                    render={({ row }) => {

                                        if (row.TGL_LAYANAN == "") {
                                            return <b style={{ fontSize: 16 }}>{ }</b>
                                        } else {
                                            return <>{row.HARGA_KONSULTASI}</>
                                        }
                                    }}
                                ></GridColumn>


                                <GridColumn
                                    field="TOTAL_HARGA"
                                    title="DISKON"
                                    align="center"
                                    width="40px"
                                    render={({ row }) => {

                                        if (row.TGL_LAYANAN == "") {
                                            return <><b>TOTAL</b></>
                                        } else {
                                            return <>
                                                {row.PEMBAYARAN_KONSULTASI == 0 ? "-" : null}
                                                {row.PEMBAYARAN_KONSULTASI == 1 || row.PEMBAYARAN_KONSULTASI == 3 ? "FREE" : null}
                                                {row.PEMBAYARAN_KONSULTASI == 2 ? row.PEMBAYARAN_DISKON + "%" : null}

                                            </>
                                        }
                                    }}
                                ></GridColumn>




                                <GridColumn
                                    field="TOTAL_HARGA"
                                    title="BIAYA KONSULTASI"
                                    align="center"
                                    width="100px"
                                    hidden={Cookies.get('biomedika-level') == 5 ? false : true}
                                    render={({ row }) => {

                                        let _step1 = row.HARGA_KONSULTASI - ((row.PEMBAYARAN_DISKON / 100) * row.HARGA_KONSULTASI);
                                        let _pembayaranKonsultasi = "Rp." + numberFormat(_step1 - ((25 / 100) * _step1)).replace("Rp", "");

                                        if (row.TGL_LAYANAN == "") {
                                            return <b style={{ fontSize: 16 }}>{"Rp." + numberFormat(row.KONSULTASI_HARGA).replace("Rp", "")}</b>
                                        } else {
                                            return <>{row.PEMBAYARAN_KONSULTASI == 1 || row.PEMBAYARAN_KONSULTASI == 3 ? "Rp." + numberFormat(0).replace("Rp", "") : null}
                                                {row.PEMBAYARAN_KONSULTASI == 0 ? "Rp." + numberFormat(row.HARGA_KONSULTASI - ((25 / 100) * row.HARGA_KONSULTASI)).replace("Rp", "") : null}
                                                {row.PEMBAYARAN_KONSULTASI == 2 ? _pembayaranKonsultasi : null}

                                            </>
                                        }
                                    }}
                                ></GridColumn>
                                <GridColumn
                                    field="TOTAL_HARGA"
                                    title="BIAYA ADMINISTRASI"
                                    align="center"
                                    width="100px"
                                    hidden={Cookies.get('biomedika-level') == 5 ? false : true}
                                    render={({ row }) => {
                                        let _step2 = row.HARGA_KONSULTASI - ((row.PEMBAYARAN_DISKON / 100) * row.HARGA_KONSULTASI);
                                        let _pembayaranBio = "Rp." + numberFormat((25 / 100) * _step2).replace("Rp", "");
                                        if (row.TGL_LAYANAN == "") {
                                            return <b style={{ fontSize: 16 }}>{"Rp." + numberFormat(row.DOKTER_HARGA).replace("Rp", "")}</b>
                                        } else {
                                            return <> {row.PEMBAYARAN_KONSULTASI == 1 || row.PEMBAYARAN_KONSULTASI == 3 ? "Rp." + numberFormat(row.TOTAL_HARGA).replace("Rp", "") : null}
                                                {row.PEMBAYARAN_KONSULTASI == 0 ? "Rp." + numberFormat(((25 / 100) * row.TOTAL_HARGA)).replace("Rp", "") : null}
                                                {row.PEMBAYARAN_KONSULTASI == 2 ? _pembayaranBio : null}
                                            </>
                                        }
                                    }}
                                ></GridColumn>
                                <GridColumn
                                    field="TOTAL_HARGA"
                                    title="TOTAL PEMBAYARAN"
                                    align="center"
                                    width="100px"
                                    render={({ row }) => {
                                        if (row.TGL_LAYANAN == "") {
                                            return <b style={{ fontSize: 16 }}>{"Rp." + numberFormat(row.TOTAL_HARGA).replace("Rp", "")}</b>
                                        } else {
                                            return <>{"Rp." + numberFormat(row.TOTAL_HARGA).replace("Rp", "")}</>
                                        }
                                    }}
                                ></GridColumn>
                            </DataGrid>
                        </div>
                    </Panel >
                </div >
            </Row >
        )
    }
}
export default MasterKonsultasi